module.exports = __webpack_public_path__ + "media/ubud/monkey-d39c69d0.jpg";